import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import VideoModal from '../../../../components/VideoModal';
import UserPlayIcon from '../../../../images/SideBar/UserPlay';
import { apiPaths } from '../../../../service/apiPaths';
import ApiService from '../../../../service/ApiService';
import { formatDate, style, stylePriority } from '../../../../util/constant';

const TaskDetail: React.FC = () => {
  const { id } = useParams();
  console.log("id",id);
  const navigate = useNavigate();
  const [task, setTask] = React.useState<any | null>(null);
  const [employee, setEmployee] = React.useState<any | null>(null);
  const [project, setProject] = React.useState<any | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [isVideoModalOpen, setIsVideoModalOpen] = React.useState(false);

  React.useEffect(() => {
    const fetchTaskDetails = async () => {
      try {
        const response = await ApiService({
          method: "GET",
          endpoint: `${apiPaths.getAllTaskSheets}?id=${id}`,
        });

        const employees = response?.data?.employees || [];
        let foundTask: any = null;
        let foundEmployee: any = null;
        let foundProject: any = null;

        for (const emp of employees) {
          for (const proj of emp.projects || []) {
            for (const t of proj.tasks || []) {
              if (t?._id === id) {
                foundTask = t;
                foundEmployee = emp.employee;
                foundProject = proj.project;
                break;
              }
            }
            if (foundTask) break;
          }
          if (foundTask) break;
        }

        // If API already returns only the requested task nested, fallback to first
        if (!foundTask && employees[0]?.projects?.[0]?.tasks?.[0]) {
          const t = employees[0].projects[0].tasks[0];
          foundTask = t;
          foundEmployee = employees[0].employee;
          foundProject = employees[0].projects[0].project;
        }

        if (foundTask) {
          setTask(foundTask);
          setEmployee(foundEmployee);
          setProject(foundProject);
        } else {
          setTask(null);
        }
      } catch (error) {
        console.error("Error fetching task details:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchTaskDetails();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!task) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-red-500 text-xl font-semibold">Task not found</div>
      </div>
    );
  }


  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <svg
              className="mr-2 h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Back
          </button>
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="px-6 py-4 bg-gradient-to-r from-blue-500 to-blue-600">
            <h1 className="text-2xl font-bold text-white">Task Details</h1>
          </div>

          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="bg-gray-50 rounded-lg p-4">
                  <h2 className="text-lg font-semibold text-gray-900 mb-4">
                    Basic Information
                  </h2>

                  <div className="space-y-4">
                    <div>
                      <h3 className="text-sm font-medium text-gray-500">
                        Project
                      </h3>
                      <p className="mt-1 text-lg text-gray-900">
                        {project?.name}
                      </p>
                    </div>

                    <div>
                      <h3 className="text-sm font-medium text-gray-500">
                        Assigned To
                      </h3>
                      <p className="mt-1 text-lg text-gray-900">
                        {employee?.name}
                      </p>
                    </div>

                    <div>
                      <h3 className="text-sm font-medium text-gray-500">
                        Priority
                      </h3>
                      <span
                        className={`mt-1 inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${stylePriority[task.priority]}`}
                      >
                        {task.priority}
                      </span>
                    </div>

                    <div>
                      <h3 className="text-sm font-medium text-gray-500">
                        Status
                      </h3>
                      <span
                        className={`mt-1 inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${style[task.status]}`}
                      >
                        {task.status}
                      </span>
                    </div>

                    {task.videoUrl && (
                      <div>
                        <h3 className="text-sm font-medium text-gray-500">
                          Video
                        </h3>
                        <button
                          onClick={() => setIsVideoModalOpen(true)}
                          className="mt-1 inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                          <svg
                            className="mr-2 h-5 w-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          Watch Video
                        </button>
                      </div>
                    )}
                    {task.userVideoUrl && (
                      <div>
                        <h3 className="text-sm font-medium text-gray-500">
                          User Video
                        </h3>
                        <button
                          onClick={() => setIsVideoModalOpen(true)}
                          className="mt-1 inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                          <UserPlayIcon />
                          Watch Video
                        </button>
                      </div>
                    )}


                    {task.query && (
                      <div>
                        <h3 className="text-sm font-medium text-gray-500">
                          Query
                        </h3>
                        <p className="mt-1 text-gray-900 bg-white p-3 rounded-md border border-gray-200">
                          {task.query}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Right Column - Additional Details */}
              <div className="space-y-6">
                <div className="bg-gray-50 rounded-lg p-4">
                  <h2 className="text-lg font-semibold text-gray-900 mb-4">
                    Additional Details
                  </h2>

                  <div className="space-y-4">
                    <div>
                      <h3 className="text-sm font-medium text-gray-500">
                        Description
                      </h3>
                      <p className="mt-1 text-gray-900 whitespace-pre-wrap bg-white p-3 rounded-md border border-gray-200">
                        {task.description}
                      </p>
                    </div>

                    <div>
                      <h3 className="text-sm font-medium text-gray-500">
                        Created At
                      </h3>
                      <p className="mt-1 text-gray-900">
                        {formatDate(task.createdAt)}
                      </p>
                    </div>

                    <div>
                      <h3 className="text-sm font-medium text-gray-500">
                        Due Date
                      </h3>
                      <p className="mt-1 text-gray-900">
                        {formatDate(task.dueDate)}
                      </p>
                    </div>

                    <div>
                      <h3 className="text-sm font-medium text-gray-500">
                        Hours
                      </h3>
                      <p className="mt-1 text-gray-900">{task.hours}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {task.videoUrl && (
        <VideoModal
          isOpen={isVideoModalOpen}
          onClose={() => setIsVideoModalOpen(false)}
          videoUrl={task.videoUrl}
          title="Task Video"
        />
      )}
    </div>
  );
};

export default TaskDetail;
